// Validation Rules rows 1–2 (item 9) — the words for a rule's Enforcement, the
// value the server derives from the rule's implementation (never its text).
export const ENFORCEMENT_LABELS: Record<string, string> = {
  enforced: 'Enforced',
  advisory: 'Advisory',
  'not-yet-enforced': 'Not yet enforced',
};

export const ENFORCEMENT_TITLES: Record<string, string> = {
  enforced: 'The validator can fail this rule at error severity; a failure blocks compile unless overridden.',
  advisory: 'The validator can fail this rule, at warning/info severity: shown in results, never blocks compile.',
  'not-yet-enforced': 'The implementation has no fail outcome: it only passes or skips, so nothing is enforced yet.',
};
